import { createFileRoute } from '@tanstack/react-router'
import { StaffPembangunan } from '../../../../components/StaffPembangunan'

export const Route = createFileRoute('/desa/$slug/dashboard/pembangunan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffPembangunan desaId={desaId} />
  },
})
